import * as React  from 'react'
import { connect } from 'react-redux'

import { AccountType }                         from '../../api'
import { ApplicationState, selectAccountType } from '../../redux'

const mstp = (state: ApplicationState) => ({
  accountType: selectAccountType(state),
})

interface InjectedAccountTypeProps {
  accountType: AccountType
}

interface AccountTypeProps {
  children: (props: InjectedAccountTypeProps) => JSX.Element
}

type Props =
  AccountTypeProps
  & ReturnType<typeof mstp>

const InjectAccountType: React.SFC<Props> = ({ accountType, children }) => {
  if (!accountType) return null

  return children({ accountType })
}

export default connect(mstp)(InjectAccountType)



// WEBPACK FOOTER //
// ./src/components/atoms/InjectAccountType.tsx